// 法人情報新規登録インプットフィールドのグループ
import React, { memo } from 'react';
import ValidMessage from '../atoms/ValidMessage';
import { InputDataType, ValidMessageType } from '../../ts/types/Corporate';

interface Props {
  id: string;
  input_data: InputDataType[];
  valid_message: ValidMessageType[];
  handleInput: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleBlur: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const CorporateEntryInputGroup: React.FC<Props> = ({
  id,
  input_data,
  valid_message,
  handleInput,
  handleBlur,
}) => {
  /**
   * バリデーションエラーがあるか判定する処理
   * @param name アイテムのキー名
   * @returns index
   */
  const findValidMessageIndex = (name: string) => {
    if (valid_message.length === 0) return -1;

    return valid_message.findIndex((item: ValidMessageType) => item.form_name === name);
  };

  return (
    <>
      {input_data.map((item: InputDataType, index) => (
        <dl className="field_section" key={index}>
          <dt className="field_label">{item.label}</dt>
          <dd>
            <input
              className={`form-control w-100 ${findValidMessageIndex(item.name) !== -1 &&
                'form-control-error'}`}
              defaultValue={item.value}
              value={item.value}
              id={id}
              name={item.name}
              type={item.type}
              onChange={e => handleInput(e)}
              onBlur={e => handleBlur(e)}
              onKeyPress={e => {
                if (e.key === 'Enter') {
                  e.preventDefault();
                  e.currentTarget.blur();
                }
              }}
            />
            {findValidMessageIndex(item.name) !== -1 && (
              <span className="valid_message">
                <ValidMessage message={valid_message[findValidMessageIndex(item.name)].message} />
              </span>
            )}
          </dd>
        </dl>
      ))}
    </>
  );
};

export default memo(CorporateEntryInputGroup);
